// broadcastUsersReducer.js
import {
  FETCH_BROADCASTUSERS_REQUEST,
  FETCH_BROADCASTUSERS_SUCCESS,
  FETCH_BROADCASTUSERS_FAILURE,
  RESET_BROADCASTUSERS_LIST
} from '../../Components/BroadcastMessage/broadcastUsersActions';

const initialState = {
  list: [],
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    hasNext: false
  },
  searchTerm: ''
};

const broadcastUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BROADCASTUSERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_BROADCASTUSERS_SUCCESS:
      const { broadcastUsers, pagination, reset, searchTerm } = action.payload;
      
      return {
        ...state,
        loading: false,
        list: reset ? broadcastUsers : [...state.list, ...broadcastUsers],
        pagination: {
          currentPage: pagination.currentPage,
          totalPages: pagination.totalPages,
          totalCount: pagination.totalCount,
          hasNext: pagination.currentPage < pagination.totalPages
        },
        searchTerm: searchTerm || state.searchTerm,
        error: null
      };

    case FETCH_BROADCASTUSERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        list: []
      };

    case RESET_BROADCASTUSERS_LIST:
      return {
        ...initialState,
        loading: true // Set loading true when resetting for new search
      };

    default:
      return state;
  }
};

export default broadcastUsersReducer;